class BroadCastChannel {
  constructor(channelName) {
    if (BroadCastChannel.instance) {
      return BroadCastChannel.instance;
    }
    
    this.channel = null;
    this.init(channelName);
    BroadCastChannel.instance = this;
  }

  // Initialize the broadcast channel with the given channel name
  init(channelName) {
    if (this.channel) {
      this.channel.close();
    }
    this.channel = new BroadcastChannel(channelName);
  }

  // Post a message to the channel
  postMessage(message) {
    if (this.channel) {
      this.channel.postMessage(message);
    }
  }

  // Close the channel
  close() {
    if (this.channel) {
      this.channel.close();
      this.channel = null;
    }
  }

  // Set up the onMessage callback listener for receiving messages
  onMessage(callback) {
    if (this.channel) {
      this.channel.onmessage = (event) => {
        callback(event.data);
      };
    }
  }
}

module.exports = BroadCastChannel;
